import { render, staticRenderFns } from "./ReportsVideoCall.vue?vue&type=template&id=1f20068e"
import script from "./ReportsVideoCall.vue?vue&type=script&lang=js"
export * from "./ReportsVideoCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports